import gql from 'graphql-tag';

export const GET_BENCHLING_ENTITY_WEB_URL = gql`
    query($entityId:String!){
        getBenchlingEntityWebUrl(entityId:$entityId)
    }
`;